<template>
  <section class="d-flex flex-column h-full">
    <!-- <TopAppBar
            :leftBtnMode="leftBtnMode"
            :title="title"
            :leftBtnMethod="leftBtnMethod"
            :rightBtnMethod="rightBtnMethod"
            staticMode="true"
        >
    </TopAppBar>-->
    <div class="flex-grow-1 scroll-y">
      <ePromoterList></ePromoterList>
      <transition name="fade" mode="out-in">
        <router-view></router-view>
      </transition>
    </div>
  </section>
</template>

<script>
/**
 * 나의 학습 메인 컴포넌트(my learn main component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
//import TopAppBar from '@/components/TopAppBar.vue'
//import {topAppBarMixin} from '@/mixins/topAppBar.js'
//import LearnList from '@/components/learn/List'
// import SocialLearningList from "@/components/socialLearning/List";
import ePromoterList from "@/components/ePromoter/List";

export default {
  name: "EPromoter",

  data() {
    return {};
  },
    components: {
      ePromoterList,
    },
};
</script>
